export default function confirmPopup(message, callback, closeCallback) {
	return (dispatch) => {
		dispatch({
			type: 'CONFIRM_POPUP',
			payload: {message, callback, closeCallback},
		});
	};
}